export default {"src":"/_next/static/media/motorsport.d5b4dc3e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};